import { createSelector } from "reselect"
import { StatisticsState } from "./types"

export const getStatisticsData = (state: { statistics: StatisticsState }) => state.statistics
export const getStatisticsLoading = (state: { statistics: StatisticsState }) =>
  state.statistics.loading
export const getStatisticsLinks = createSelector(getStatisticsData, (data) => {
  return data?.links
})
